"use client"

import { useState } from "react"
import { useQueryClient } from "@tanstack/react-query"
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "~/components/ui/alert-dialog"
import { AsyncButton } from "~/components/ui/async-button"
import { plansQueryKey } from "../hooks/use-plans"
import { deleteSavedCard } from "../server/plans.functions"

export function DeleteCardLink({ disabled }: { disabled?: boolean } = {}) {
  const [open, setOpen] = useState(false)
  const queryClient = useQueryClient()

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        disabled={disabled}
        className="text-sm text-destructive whitespace-nowrap disabled:opacity-50"
      >
        Отвязать карту
      </button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent onDismiss={() => setOpen(false)}>
          <AlertDialogHeader>
            <AlertDialogTitle>Отвязать карту?</AlertDialogTitle>
            <AlertDialogDescription>
              Карта больше не будет привязана к вашему аккаунту. Чтобы возобновить подписку, потребуется ввести её снова.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Назад</AlertDialogCancel>
            <AsyncButton
              variant="destructive"
              fn={() => deleteSavedCard()}
              onSuccess={async () => {
                setOpen(false)
                await queryClient.invalidateQueries({ queryKey: plansQueryKey })
              }}
            >
              Отвязать
            </AsyncButton>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  )
}
